module.exports = __webpack_public_path__ + "static/media/yesterdayImage.0b7d71c7.png";